import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'

import { Observable } from 'rxjs'

import { environment } from '../../../environments/environment'

import { SKU } from '../models/sku'

import { compare } from '../../core/helpers/sorting'

@Injectable()
export class SKUService {
    constructor(
        private http: HttpClient
    ) {}

    getSKUs(product: string): Observable<SKU[]> {
        let url = `/products/${product}/variants`

        return this.http.get<SKU[]>(
            environment.baseApiUrl + url).pipe(
            map(skus => skus.sort(compare(sku => sku.code))))
    }
}
